<!--  -->
<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">评价编码：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.evaluationCode || ""
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">评价办法：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.evaluateMethodName || ""
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">专业：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.specialtyName || ""
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">适用范围：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.supplierType || ""
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">现场审查费：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.siteReviewFee || ""
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">是否有单元分项：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.multiProduct || ""
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">是否检测等级：</span>
        <span class="e-descriptions-item-content">{{
          evaluationInfo.productMultiLevel || ""
        }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    evaluationInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.e-descriptions-item-label,
.e-descriptions-item-content {
  font-size: 14px;
  color: #333;
  line-height: 1;
}
.e-descriptions-item-label {
  display: inline-block;
  width: 115px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.el-row {
  line-height: 1;
}
.el-row:not(:last-child) {
  margin-bottom: 20px;
}
.el-col {
  display: flex;
}
</style>
